// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"AddsTable_saveButton__1pU_V"};